export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Automation Engineer | London',
    'I finally understand the complete picture of industrial automation—from PLC fundamentals through control logic, sensors, HMI/SCADA, communication, and troubleshooting. This resource transformed how I approach automation projects professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Industrial Technician | Dublin',
    'I know exactly how to explain PLC architecture, control sequences, industrial signals, communication protocols, and system reliability. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Controls Specialist | Amsterdam',
    'The technical depth saves me countless hours. The integrated scenarios are organized step-by-step. I never struggle with technical explanations anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Automation Professional',
    "PLC architecture and control logic completely changed how I understand automation systems. It's the clearest technical resource I've found.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Industrial Technician',
    'The technical glossary and troubleshooting reference alone are worth the price. I never struggle with technical terminology or fault analysis anymore. Everything is organized and accessible.',
  ],
  [
    'MS',
    'Martin S.',
    'Controls Engineer',
    'The 30 practical scenarios and 40 concept connections were eye-opening. I can now explain PLC fundamentals, control sequences, sensor integration, HMI communication, and troubleshooting across conveyor systems, packaging lines, tank control, and advanced manufacturing. This transformed my professional credibility.',
  ],
];
